import { render, staticRenderFns } from "./wtToolboxBgmusic.vue?vue&type=template&id=05c3759e&scoped=true&"
import script from "./wtToolboxBgmusic.vue?vue&type=script&lang=js&"
export * from "./wtToolboxBgmusic.vue?vue&type=script&lang=js&"
import style0 from "./wtToolboxBgmusic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wtToolboxBgmusic.vue?vue&type=style&index=1&id=05c3759e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c3759e",
  null
  
)

export default component.exports